export default "__VITE_ASSET__czHY0Nox__"